import srApi from '@/services/api';
const api = srApi.create({ baseUrl: '/' });
import get from "lodash/get";
import userData from "@/services/clientUserData";
import SegmentTrack from "@/utils/segment";

export class SchoolSearchTrackingService {
  constructor(filterOptions, positionsMap, userId) {
    this.filterOptions = filterOptions;
    this.majorParentChildRelationship = this.mapMajorParents(filterOptions.majors);
    this.appliedFilters = {};
    this.positionsMap = positionsMap;
    this.totalResults = 0;
    this.userId = userId;
    this.sections = {
      schoolName: params => this.getParamsForSchoolName(params),
      location: params => this.getParamsForLocation(params),
      academics: params => this.getParamsForAcademics(params),
      majors: params => this.getParamsForMajors(params),
      athletics: params => this.getParamsForAthletics(params),
      needs: params => this.getParamsForNeeds(params)
    };
  }

  async trackInDb(appliedFilters, totalResults) {
    this.appliedFilters = appliedFilters;
    this.totalResults = totalResults;

    let selectedFilters = this.getSelectedFilters();

    const response = await api.postFormData('/search/track_search', {
      selectedFilters: selectedFilters,
    });

    return {
      selectedFilters: selectedFilters,
      response: response,
    }
  }

  getSelectedFilters() {
    let params = {
      satMax: get(this.appliedFilters, 'academics.satScore', 0),
      actMax: get(this.appliedFilters, 'academics.actScore', 0),
      acceptanceMin: get(this.appliedFilters, 'academics.acceptanceRate.min', 0),
      acceptanceMax: get(this.appliedFilters, 'academics.acceptanceRate.max', 100),
      schoolsCount: this.totalResults,
    }

    Object.keys(this.appliedFilters).forEach(section => this.sections[section](params));

    return params;
  }

  getParamsForSchoolName(params) {
    params.searchKeyword = this.appliedFilters.schoolName.schoolName;

    return params;
  }

  getParamsForLocation(params) {
    if (this.appliedFilters.location.distance) {
      params.zipcode = this.appliedFilters.location.distance.zipcode;
      params.distance = this.appliedFilters.location.distance.radius === 1000000000 ? '' : this.appliedFilters.location.distance.radius;
    }

    if (this.appliedFilters.location.regions) {
      params.regions = this.appliedFilters.location.regions.regions;
    }

    return params;
  }

  getParamsForAcademics(params) {
    if (this.appliedFilters.academics.selectivity) {
      params.selectivity = this.appliedFilters.academics.selectivity;
    }

    if (this.appliedFilters.academics.enrollment) {
      params.enrollment = this.appliedFilters.academics.enrollment;
    }
  }

  getParamsForMajors(params) {
    params.majors = this.appliedFilters.majors.majors.filter(major => {
      return this.majorParentChildRelationship[major] === null || this.appliedFilters.majors.majors.indexOf(this.majorParentChildRelationship[major]) === -1;
    })
    .map(major => ({ id: major }));
  }

  getParamsForAthletics(params) {
    if (this.appliedFilters.athletics.divisions) {
      params.divisions = this.appliedFilters.athletics.divisions;
    }

    if (this.appliedFilters.athletics.conferences) {
      params.conferences = [];

      this.appliedFilters.athletics.conferences.forEach(id => {
        let conference = this.filterOptions.athletics.conferences.find(({ value }) => value == id);

        params.conferences.push({
          id: conference.value,
          name: conference.label,
        });
      });
    }
  }

  getParamsForNeeds(params) {
    let needsFilters = this.cleanAppliedNeedsFilters(this.appliedFilters.needs.needs);

    params.needs = needsFilters.map(filter => {
      const needsFilterData = {filterType: null, classYear: null, sportOption: null};

      const filtersPathSegments = filter.split('.');
      
      filtersPathSegments.forEach((filter, index) => {
        if(index === 0)
          needsFilterData.filterType = ['full', 'potential'].includes(filter) ? filter : 'all';
  
        if(!isNaN(filter)) {
          needsFilterData.classYear = filter;
          return;
        }
        
        if(index !== 0) {
          needsFilterData.sportOption = this.positionsMap[filter];
        }
      })

      return needsFilterData
    });
  }

  cleanAppliedNeedsFilters(appliedNeedsFilters) {
    let needsFilters = appliedNeedsFilters;

    if(userData.isClubStaff) {
      if(needsFilters.includes('all'))
        needsFilters = needsFilters.filter(filter => filter.includes(`all`));
      
      needsFilters.forEach(filter => {
        if(!isNaN(filter)) {
          needsFilters = needsFilters.filter(f => !f.includes(`${filter}.`));
        }
      })
    } 

    if(userData.isPlayer) {
      ['full', 'potential'].forEach(filter => {
        if(needsFilters.includes(filter)) {
          needsFilters = needsFilters.filter(f => !f.includes(`${filter}.`));
        }
      })
  
      if(needsFilters.includes('all')) {
        needsFilters = needsFilters.filter(filter => !filter.includes(`non-match.`));
        needsFilters = needsFilters.filter(filter => isNaN(filter));
      }

      needsFilters.forEach(filter => {
        if(!isNaN(filter)) {
          needsFilters = needsFilters.filter(f => !f.includes(`non-match.${filter}.`));
        }
      })
    }

    return needsFilters;
  }

  mapMajorParents(options, parent, map) {
    map = map ? map : {};

    options.forEach(option => {
      map[option.value] = parent ? parent : null;

      if (option.children) {
        option.children.forEach(child => this.mapMajorParents([child], option.value, map));
      }
    });

    return map;
  }

  segmentTrack(event, data) {
    SegmentTrack(event, { user_id: this.userId, ...data });
  }
}


export default SchoolSearchTrackingService;